module.exports = __webpack_public_path__ + "static/media/coursera-logo-black-transparent.50426a72.png";